/** Optional Key Insights clause when interpolated/extrapolated years appear in the active chart. */
export function estimatedYearsKeyInsightsSentence(hasEstimatedYears: boolean): string {
  if (!hasEstimatedYears) return '';
  return (
    ' Where the chart legend includes Interpolated or Extrapolated series, those colors mark filled years; Observed marks utility-reported sales.'
  );
}

export function buildElectricityChartProvenanceGuidance(
  hasEstimatedYears: boolean,
  locationName: string
): string[] {
  if (!hasEstimatedYears) {
    return [
      `For ${locationName}, each year in the residential and reported-commercial electricity charts is utility-reported (Observed in the chart legend). No interpolated or model-extrapolated gap-fill years are shown for the active series.`,
    ];
  }
  return [
    'Reading the bar chart legend: Observed = utility-reported sales for that customer class and year.',
    'Interpolated = values filled between observed anchor years (including years adjusted in Customize).',
    'Extrapolated = years filled by the residential and/or commercial model selected above the chart; the legend names the active model when applicable.',
    'The stacked total view sums residential and reported-commercial values only for years where both sectors have data; each sector keeps its own Observed / Interpolated / Extrapolated coloring.',
  ];
}

export function buildNaturalGasChartProvenanceGuidance(
  hasEstimatedYears: boolean,
  locationName: string
): string[] {
  if (!hasEstimatedYears) {
    return [
      `For ${locationName}, each year in the residential and commercial natural-gas charts is utility-reported (Observed in the chart legend). No interpolated or model-filled gap years are shown for the active series.`,
    ];
  }
  return [
    'Reading the bar chart legend: Observed = utility-reported therms for that customer class and year.',
    'Interpolated = values filled between observed anchor years (including years adjusted in Customize).',
    'Extrapolated = years filled by the residential and/or commercial model selected above the chart.',
    'The stacked total view sums residential and commercial values only for years where both sectors have data.',
  ];
}
